
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store' //引入 Vuex 状态管理
import './components/style.css'
import './components/font.css'
// 引入 v-charts
import VCharts from 'v-charts'


import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
  ak: 'RzNGNIohlBWZqAIlhLb20sdoTLkR2hqU'
})

import {
  setupComponents
} from './config/setup-components';
Vue.config.productionTip = false;

Vue.use(VCharts);

setupComponents(Vue);

new Vue({
  vuetify,
  render: h => h(App),
  router,
  store,
  data: {
    themeColor: '#1D2939'
  }
}).$mount('#app')